<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-confirm-login">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" style="text-align:left;">Bạn chắc chắn muốn truy cập</h2>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary btn-sm pull-right"
              @click="accessPeriodicTask"
            >{{$t('common.yes')}}</button>
            <button
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{$t('common.no')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from '@/lib/utils'

export default {
  name: "ModalPeriodicTask",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    submit() {
      $("#modal-confirm-login").modal("show");
    },

    closeModal: function() {
      $("#modal-confirm-login").modal("hide");
    },
    accessPeriodicTask: function() {
      let periodicURL = utils.getPeriodicURL();
      window.open(periodicURL)
      $("#modal-confirm-login").modal("hide");
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST"
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/ModalPeriodicTask.vue